<template>
  <div
    class="el-media-wrapper"
    :style="{...fullPaddingSubject(section.options.content.media), ...fullMarginSubject(section.options.content.media)}"
  >
    <slot />
  </div>
</template>

<script>
import TemplateMixin from '@builder/components/mixins/TemplateMixin'
import BorderMixin from '@/components/mixins/BorderMixin'

export default {
  name: 'ImageItem1Template',
  mixins: [TemplateMixin, BorderMixin]
}
</script>